import { CompanyDocument } from 'components/CompanyDocument';
import { ICompanyFile } from 'types/Company';

import { Grid } from '@mui/material';

type Props = {
  idCompany?: string;
  documents: ICompanyFile[] | null;
};

export const CompanyDocuments: React.FC<Props> = ({ idCompany, documents }) => {
  if (!documents) {
    return null;
  }

  return (
    <Grid container item spacing={2} mt={2} xs={12} md={12}>
      {documents.map((document) => (
        <CompanyDocument
          key={document._id ?? document.file?.name}
          document={document}
          companyId={idCompany}
        />
      ))}
    </Grid>
  );
};

